































import {Component, Vue} from "vue-property-decorator";
import {PostOfficeStore} from "@/modules/postoffices/store";
import CommonStatusLabel from "@/shared/components/CommonStatusLabel/index.vue";
import PostOfficeTableAction from "@/modules/postoffices/List/components/TableAction.vue";
import {PostOfficeParams} from "@/modules/postoffices/params";
import PostOfficeSearch from "@/modules/postoffices/List/components/Search.vue";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";

@Component({
    name: "PostOfficeList",
    components: {PostOfficeSearch, PostOfficeTableAction, CommonStatusLabel}
})
export default class extends Vue {
    columns = [
        {
            title: "Thao tác",
            dataIndex: "rowGuid",
            key: "rowGuid",
            scopedSlots: {customRender: 'action'},
            width: 100
        },
        {
            title: "Mã bưu cục",
            dataIndex: "postOfficeCode",
            key: "postOfficeCode",
            ellipsis: true
        },
        {
            title: "Tên bưu cục",
            dataIndex: "name",
            key: "name",
            ellipsis: true
        },
        {
            title: "Số điện thoại",
            dataIndex: "phoneNumber",
            key: "phoneNumber",
            ellipsis: true
        },
        {
            title: "Giám đốc",
            dataIndex: "directorName",
            key: "directorName",
            ellipsis: true
        },
        {
            title: "Trạng thái",
            dataIndex: "status",
            key: "status",
            scopedSlots: {customRender: 'status'},
        }
    ];

    created() {
        PostOfficeStore.updatePostOfficeParams(new PostOfficeParams());
        PostOfficeStore.listPostOffice(PostOfficeStore.params)
    }

    get postOffices() {
        return PostOfficeStore.postOffices;
    }

    get pagination() {
        return {
            current: PostOfficeStore.meta.page,
            pageSize: PostOfficeStore.meta.limit,
            total: PostOfficeStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} bưu cục`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onChangePage(pagination: any) {
        PostOfficeStore.listPostOffice({
            ...PostOfficeStore.params,
            page: pagination.current,
            limit: pagination.pageSize
        });
    }
}
